"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextGroupId = exports.getNextFormId = exports.getNextQuestionId = exports.createIncrementer = void 0;
const createIncrementer = () => {
    return (() => {
        let questionIdCounter = 1;
        return () => questionIdCounter++;
    })();
};
exports.createIncrementer = createIncrementer;
exports.getNextQuestionId = (0, exports.createIncrementer)();
exports.getNextFormId = (0, exports.createIncrementer)();
exports.getNextGroupId = (0, exports.createIncrementer)();
